import * as React from "react";
const ErrorMessageContext = React.createContext(null);
ErrorMessageContext.displayName = "ErrorMessageContext";
const useErrorMessageContext = () => {
  const context = React.useContext(ErrorMessageContext);
  if (!context) {
    throw new Error(
      "No Error Message Context available. You might still need to wrap the application with the ErrorMessageProvider component."
    );
  }
  return context;
};
export {
  ErrorMessageContext,
  useErrorMessageContext
};
//# sourceMappingURL=context.js.map
